"use strict";

var _toConsumableArray = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _regeneratorRuntime = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator/index.js");
var _slicedToArray = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/slicedToArray.js");
require("core-js/modules/es.object.from-entries.js");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChainsWithDefault = exports.getBestUrlMap = exports.isArrayOneOrMore = void 0;
/**
 * This is a type guard for ArrayOneOrMore
 */
function isArrayOneOrMore() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return input.length > 0;
}
exports.isArrayOneOrMore = isArrayOneOrMore;
/**
 * @param rpcMap - Map of chainIds to rpc url(s).
 * @param timeout - Timeout, in milliseconds, after which to consider network calls failed.
 */
function getBestUrlMap(rpcMap, timeout) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _this = this;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.t0 = Object;
          _context2.next = 3;
          return Promise.all(Object.entries(rpcMap).map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              chainId = _ref2[0],
              map = _ref2[1];
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.t0 = chainId;
                    _context.next = 3;
                    return getBestUrl(map, timeout);
                  case 3:
                    _context.t1 = _context.sent;
                    return _context.abrupt("return", [_context.t0, _context.t1]);
                  case 5:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
          }));
        case 3:
          _context2.t1 = _context2.sent;
          return _context2.abrupt("return", _context2.t0.fromEntries.call(_context2.t0, _context2.t1));
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
}
exports.getBestUrlMap = getBestUrlMap;
/**
 * @param urls - An array of URLs to try to connect to.
 * @param timeout - {@link getBestUrlMap}
 */
function getBestUrl(urls, timeout) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _yield$Promise$all, _yield$Promise$all2, HttpConnection, JsonRpcProvider;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(typeof urls === 'string')) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return", urls);
        case 2:
          if (!(urls.length === 1)) {
            _context3.next = 4;
            break;
          }
          return _context3.abrupt("return", urls[0]);
        case 4:
          _context3.next = 6;
          return Promise.all([Promise.resolve().then(function () {
            return __importStar(require('@walletconnect/jsonrpc-http-connection'));
          }).then(function (_ref3) {
            var HttpConnection = _ref3.HttpConnection;
            return HttpConnection;
          }), Promise.resolve().then(function () {
            return __importStar(require('@walletconnect/jsonrpc-provider'));
          }).then(function (_ref4) {
            var JsonRpcProvider = _ref4.JsonRpcProvider;
            return JsonRpcProvider;
          })]);
        case 6:
          _yield$Promise$all = _context3.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          HttpConnection = _yield$Promise$all2[0];
          JsonRpcProvider = _yield$Promise$all2[1];
          return _context3.abrupt("return", new Promise(function (resolve) {
            var resolved = false;
            var successes = {};
            urls.forEach(function (url, i) {
              var http = new JsonRpcProvider(new HttpConnection(url));
              // create a promise that resolves on a successful call, and rejects on a failed call or after timeout milliseconds
              var promise = new Promise(function (resolve, reject) {
                http.request({
                  method: 'eth_chainId'
                }).then(function () {
                  return resolve();
                }).catch(function () {
                  return reject();
                });
                // set a timeout to reject
                setTimeout(function () {
                  reject();
                }, timeout);
              });
              void promise.then(function () {
                return true;
              }).catch(function () {
                return false;
              }).then(function (success) {
                // if we already resolved, return
                if (resolved) return;
                // store the result of the call
                successes[i] = success;
                // if this is the last call and we haven't resolved yet - do so
                if (Object.keys(successes).length === urls.length) {
                  var index = Object.keys(successes).findIndex(function (j) {
                    return successes[Number(j)];
                  });
                  // no need to set resolved to true, as this is the last promise
                  return resolve(urls[index === -1 ? 0 : index]);
                }
                // otherwise, for each prospective index, check if we can resolve
                new Array(urls.length).fill(0).forEach(function (_, prospectiveIndex) {
                  // to resolve, we need to:
                  // a) have successfully made a call
                  // b) not be waiting on any other higher-index calls
                  if (successes[prospectiveIndex] && new Array(prospectiveIndex).fill(0).every(function (_, j) {
                    return successes[j] === false;
                  })) {
                    resolved = true;
                    resolve(urls[prospectiveIndex]);
                  }
                });
              });
            });
          }));
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
}
/**
 * @param chains - An array of chain IDs.
 * @param defaultChainId - The chain ID to treat as the default (it will be the first element in the returned array).
 */
function getChainsWithDefault(chains, defaultChainId) {
  if (!chains || !defaultChainId || chains.length === 0) {
    return chains;
  }
  var idx = chains.indexOf(defaultChainId);
  if (idx === -1) {
    throw new Error("Invalid chainId ".concat(defaultChainId, ". Make sure default chain is included in \"chains\" - chains specified in \"optionalChains\" may not be selected as the default, as they may not be supported by the wallet."));
  }
  var ordered = _toConsumableArray(chains);
  ordered.splice(idx, 1);
  return [defaultChainId].concat(_toConsumableArray(ordered));
}
exports.getChainsWithDefault = getChainsWithDefault;